//#region import libraries
import React, { useState, useMemo } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
//Custom component
import { TableHeader, TableValue } from '_molecules';
import { ClickableTable, BookingDetails } from '_organisms';

// redux
import { useSelector, useDispatch } from 'react-redux'
import { selectUserStatus, selectUserBookings, setSelectedBooking } from '../../../redux/slices/profile/user-profile'
//#endregion

const UserBookingHistory = (props) => {

    // states
    const [bookingDetails, setBookingDetails] = useState(false)   // show booking details if booking selected

    const dispatch = useDispatch();
    const userBookings = useSelector(selectUserBookings);
    const status = useSelector(selectUserStatus)

    // columns for table
    const columns = useMemo(
        () => [
            {
                Header: <TableHeader title={'Flight Number'} />,
                accessor: "flightNumber",
                Cell: ({ cell: { value } }) => <TableValue title={value} />
            },
            {
                Header: <TableHeader title={'Date'} />,
                accessor: "departureDate",
                Cell: ({ cell: { value } }) => <TableValue title={value} />
            },
            {
                Header: <TableHeader title={'Departure Airport'} />,
                accessor: "origin",
                Cell: ({ cell: { value } }) => <TableValue title={value} />
            },
            {
                Header: <TableHeader title={'Arrival Airport'} />,
                accessor: "destination",
                Cell: ({ cell: { value } }) => <TableValue title={value} />
            },
            {
                Header: <TableHeader title={'Time Created'} />,
                accessor: "dateCreated",
                Cell: ({ cell: { value } }) => {
                    if (new Date(value) != 'Invalid Date') {
                        return <p style={{ opacity: 0.4, marginLeft: 10, marginTop: 5 }}>{new Date(value).toLocaleTimeString().substring(0, 5) + ' ' + new Date(value).toLocaleDateString()}</p>
                    } else {
                        return null
                    }
                },
            },
        ],
        []
    );

    // handle selecting user
    const handleClick = (props) => {
        let selectedBooking = userBookings[props];
        setBookingDetails(true)
        dispatch(setSelectedBooking(selectedBooking))
    }

    return (
        <div style={{ marginBottom: 100 }}>
            {
                status == 'succeeded' ?
                    <>
                        <Row>
                            <ClickableTable
                                columns={columns}
                                data={userBookings ? userBookings : []}
                                handleClick={handleClick}
                                status={status}
                            />
                        </Row>

                        <Row>
                            {bookingDetails && <BookingDetails />}
                        </Row>
                    </>
                    : null
            }
        </div>
    );
};

export default UserBookingHistory;
